import account from './account';
import addons from './addons';
import airQuality from './airQuality';
import alerts from './alerts';
import appUpdate from './appUpdate';
import astral from './astral';
import auth from './auth';
import calendar from './calendar';
import charts from './charts';
import common from './common';
import compass from './compass';
import dashboard from './dashboard';
import devices from './devices';
import forecastMaps from './forecastMaps';
import forecastModels from './forecastModels';
import helpCenter from './helpCenter';
import intro from './intro';
import landing from './landing';
import metrics from './metrics';
import navigation from './navigation';
import network from './network';
import premium from './premium';
import providerHints from './providerHints';
import providerIntro from './providerIntro';
import reports from './reports';
import sensors from './sensors';
import settings from './settings';
import stations from './stations';
import thermostat from './thermostat';
import units from './units';
import weatherConditions from './weatherConditions';
import weatherMap from './weatherMap';
import weatherWarnings from './weatherWarnings';
const messages = {
    account,
    addons,
    airQuality,
    alerts,
    appUpdate,
    astral,
    auth,
    calendar,
    charts,
    common,
    compass,
    dashboard,
    devices,
    forecastMaps,
    forecastModels,
    helpCenter,
    landing,
    metrics,
    navigation,
    network,
    premium,
    providerHints,
    providerIntro,
    reports,
    sensors,
    settings,
    stations,
    thermostat,
    units,
    weatherConditions,
    intro,
    weatherMap,
    weatherWarnings,
};
export default messages;
